<template>
    <div class="question-card">
        <div class="header">
            <div class="title">答题卡</div>
            <div class="question-status">
                <span class="success">正确</span>
                <span class="error">错误</span>
                <span class="unfinish">未答</span>
            </div>
        </div>

        <div class="module-list">
            <div class="module-item" v-for="mItem in moduleList" :key="mItem.id">
                <div class="module-unit" v-if="unitMap[mItem.id]">
                    {{ unitMap[mItem.id] }}
                </div>
                <div class="module-title" :title="mItem.title">
                    {{ mItem.title }}
                </div>
                <div class="module-container">
                    <template v-for="item in mItem.questions">
                        <div v-if="item.indexNo" :key="item.id" class="question-index">
                            <span @click="onChangeQuestion(item)" :class="questionClassMap[`q-${item.id}`]">
                                {{ item.indexNo }}
                            </span>
                        </div>
                        <div
                            v-for="childItem in item.childQuestions"
                            :key="childItem.id"
                            v-else-if="item.childQuestions"
                            class="question-index"
                        >
                            <span
                                @click="onChangeQuestion(item, childItem)"
                                :class="questionClassMap[`q-${childItem.id}`]"
                            >
                                {{ childItem.indexNo }}
                            </span>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        moduleList() {
            return this.$store.state.paperResult.moduleList
        },
        answerTime() {
            return this.$store.state.paperResult.answerTime
        },
        questionClassMap() {
            const userAnswerMap = this.$store.state.paperResult.userAnswerMap
            const map = {}
            Object.keys(userAnswerMap || {}).forEach((key) => {
                map[key] = ''
                if (userAnswerMap[key]) {
                    const { state, answer } = userAnswerMap[key]
                    if (state) {
                        map[key] = 'success-state'
                    } else if (!state && answer) {
                        map[key] = 'error-state'
                    }
                }
            })
            return map
        },
        unitMap() {
            const moduleList = this.$store.state.paperResult.moduleList
            const map = {}
            const _list = []
            moduleList.forEach((item) => {
                if (!_list.includes(item.unit)) {
                    map[item.id] = item.unit
                    _list.push(item.unit)
                }
            })
            return map
        },
    },

    methods: {
        onChangeQuestion(item, child) {
            this.$store.dispatch('paperResult/setJumpQuestion', {
                questionId: item.id,
                subQuestionId: child ? child.id : null,
            })
            this.$store.dispatch('paperResult/setQuestionCardState', false)
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/scss/paper.scss';

.question-card {
    height: 100%;
}
.header {
    height: 54px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    border-bottom: 1px solid #efefef;
    .title {
        font-size: 16px;
        font-weight: 700;
    }
    .question-status {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #99948d;
        margin-right: 40px;
        span {
            display: flex;
            align-items: center;
        }

        .success,
        .error {
            margin-right: 12px;
        }
        .success::after,
        .error::after,
        .unfinish::after {
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            margin-left: 4px;
            border-radius: 10px;
        }
        .success::after {
            background: $success-color;
        }
        .error::after {
            background: $error-color;
        }
        .unfinish::after {
            background: $unfinish-color;
        }
    }
}

.module-list {
    height: calc(100% - 70px);
    overflow-y: auto;
    .module-unit {
        margin: 8px 0 12px;
        padding: 12px 24px;
        font-weight: 600;
        font-size: 15px;
        border-bottom: 1px solid #efefef;
    }
    .module-item {
        margin: 8px 0 12px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .module-title {
        margin: 0 24px;
        font-size: 14px;
        color: #999;
        line-height: 1.6em;
        user-select: none;
    }
    .module-container {
        padding: 12px 24px 0 24px;
        display: flex;
        flex-wrap: wrap;
        gap: 24px;
        .question-index {
            display: flex;
            justify-content: center;
            span {
                user-select: none;
                width: 36px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                border-radius: 40px;
                background: $unfinish-color;
                color: #333;
                font-size: 14px;
            }
            .success-state {
                color: #ffff;
                background: $success-color;
            }
            .error-state {
                color: #ffffff;
                background: $error-color;
            }
        }
    }
}
</style>
